import { observer } from 'mobx-react-lite';
import Modal from 'ui/Modal';

import { useEffect, useState } from 'react';
import { SchemeNodeTypes } from 'consts/scheme.consts';
import { FormProvider, useForm } from 'react-hook-form';
import StopObject from './StopObject';
import useAlert from 'hooks/useAlert';
import StopObjectPath from './StopObjectPath';
import { productionStore } from 'store/mobx/production.store';

const StageStopModal = observer(({ open, setOpen, node }) => {
  const formContext = useForm();
  const { showAlert } = useAlert();

  const { handleSubmit, reset, setValue } = formContext;
  const { stopProcessIteration } = productionStore;
  const [loader, setLoader] = useState(false);

  const [objects, setObjects] = useState([]);
  const [isStorageMove, setIsStorageMove] = useState(false);

  useEffect(() => {
    if (node.children?.some((item) => item.type === SchemeNodeTypes.storage)) {
      setIsStorageMove(true);
      setObjects(node?.objects);
    } else {
      const objects = node?.children
        ?.filter((item) => item.type !== SchemeNodeTypes.qualityControl)
        ?.reduce((acc, parent) => acc.concat(parent.objects), [])
        ?.filter(
          (obj, index, self) => index === self.findIndex((o) => o.id === obj.id) && obj.derived,
        );

      setObjects(objects);
    }
  }, [node]);

  useEffect(() => {
    if (node.children?.some((item) => item.type === SchemeNodeTypes.storage)) {
      setValue(`params.type`, node.type);
    }
    return () => {
      reset();
    };
  }, []);

  const closeModal = () => {
    reset();
    setOpen(false);
  };

  const onSubmit = async (data) => {
    setLoader(true);
    const res = await stopProcessIteration(node, data);
    if (res.status) closeModal();
    else showAlert(res.message, 'error');
    setLoader(false);
  };

  return (
    <Modal
      title="Завершить этап производства"
      onClose={closeModal}
      onSubmit={handleSubmit(onSubmit)}
      open={open}
      submitText="Завершить"
      disabledSubmit={loader}
    >
      <FormProvider {...formContext}>
        {objects?.map((object, index) =>
          isStorageMove ? (
            <StopObjectPath key={index + object.id} object={object} index={index} />
          ) : (
            <StopObject key={index + object.id} object={object} index={index} />
          ),
        )}
      </FormProvider>
    </Modal>
  );
});

export default StageStopModal;
